import {customElements} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'
import type {CustomElementsPublicAPI} from '@wix/document-services-public-types'

export default function (): PublicModuleDeclaration<CustomElementsPublicAPI> {
    const {initMethod} = customElements

    return {
        initMethod
    }
}
